import React from 'react';
import { Router, Route, Switch } from 'react-router-dom';

import { useAppContext } from '../hooks';

import Signin from './signin';
import Signup from './signup';
import SetPassword from './setPassword';
import PasswordReset from './passwordReset';

function App() {
  const { history } = useAppContext();
  return (
    <Router history={history}>
      <Switch>
        <Route path="/signin" component={Signin} />
        <Route path="/signup" component={Signup} />
        <Route path="/setpassword" component={SetPassword} />
        <Route path="/password/reset" component={PasswordReset} />
      </Switch>
    </Router>
  );
}

export default App;
